import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { TILE_URL, TILE_ATTRIBUTION } from './RouteMap';

// Выбор точки склада на карте (вкладка «Доставка» настроек): перетаскиваемый
// маркер + клик по карте. Тайлы и атрибуция — те же константы, что у карты
// курьеров (RouteMap.jsx): провайдер меняется в одном месте на всю админку.
// Координаты наружу — с округлением до 6 знаков (~10 см).

function WarehouseMapPicker({ lat, lon, onChange, height = 320 }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const valid =
    Number.isFinite(lat) && Number.isFinite(lon) &&
    Math.abs(lat) <= 90 && Math.abs(lon) <= 180 && (lat !== 0 || lon !== 0);

  useEffect(() => {
    if (mapRef.current || !elRef.current) return;
    // GET тарифов всегда отдаёт координаты (склад или центр города инстанса),
    // так что фолбэк-центр практически недостижим.
    const center = valid ? [lat, lon] : [55.751244, 37.618423];
    const map = L.map(elRef.current, { attributionControl: false });
    L.control.attribution({ prefix: false, position: 'bottomright' }).addTo(map);
    L.tileLayer(TILE_URL, { attribution: TILE_ATTRIBUTION }).addTo(map);
    map.setView(center, valid ? 13 : 10);

    const icon = L.divIcon({
      className: 'wh-map-pin',
      iconSize: [0, 0],
      iconAnchor: [0, 0],
      html: '<div class="wh-map-marker" title="Склад — перетащите или кликните по карте">С</div>',
    });
    const marker = L.marker(center, { icon, draggable: true, autoPan: true }).addTo(map);
    marker.on('dragend', () => {
      const p = marker.getLatLng();
      onChangeRef.current(+p.lat.toFixed(6), +p.lng.toFixed(6));
    });
    map.on('click', (e) => {
      marker.setLatLng(e.latlng);
      onChangeRef.current(+e.latlng.lat.toFixed(6), +e.latlng.lng.toFixed(6));
    });

    mapRef.current = map;
    markerRef.current = marker;
    // Вкладка могла быть скрыта при монтировании — Leaflet не знает размеров
    setTimeout(() => map.invalidateSize(), 0);
    return () => { map.remove(); mapRef.current = null; markerRef.current = null; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Внешнее изменение координат (выбор адреса, ручной ввод) двигает маркер и карту
  useEffect(() => {
    const map = mapRef.current;
    const marker = markerRef.current;
    if (!map || !marker || !valid) return;
    const cur = marker.getLatLng();
    if (Math.abs(cur.lat - lat) < 1e-7 && Math.abs(cur.lng - lon) < 1e-7) return;
    marker.setLatLng([lat, lon]);
    map.setView([lat, lon], Math.max(map.getZoom(), 13));
  }, [lat, lon, valid]);

  return <div ref={elRef} className="wh-map" style={{ height }} />;
}

export default WarehouseMapPicker;
